// Configuration for application links
// If these are set to null, the app uses internal routes (/login, /signup, /tour)
// If set to a URL string, the buttons will redirect externally.

export const LINKS = {
  APP_URL: null, // e.g., 'https://app.brief.peroconsult.com'
  APP_SIGNUP_URL: null, // e.g., 'https://app.brief.peroconsult.com/signup'
  APP_LOGIN_URL: null, // e.g., 'https://app.brief.peroconsult.com/login'
};

export const getLink = (type: 'signup' | 'login' | 'tour' | 'home') => {
  switch (type) {
    case 'signup':
      return LINKS.APP_SIGNUP_URL || '/signup';
    case 'login':
      return LINKS.APP_LOGIN_URL || '/login';
    case 'tour':
      // Tour is usually a marketing page, so it stays internal unless specified otherwise
      return '/tour';
    case 'home':
      return '/';
    default:
      return '/';
  }
};